import { isNil, test } from 'ramda';
import { PHONE_REGEX } from 'constants/forms';
import i18n from 'services/i18n';

export const validatePhoneArray = phoneValues => {
  let errors = {};

  if (!phoneValues.filter(phone => !isNil(phone)).length) {
    errors = { _error: i18n.t('validation:onePhoneRequired') };
  } else {
    const arrayErrors = [];

    phoneValues.forEach((phone, index) => {
      const phoneErrors = {};

      if (!phone || !phone.phone) {
        phoneErrors.phone = i18n.t('validation:phoneAndTypeRequired');
        arrayErrors[index] = phoneErrors;
      }

      if (!phone || !phone.type) {
        phoneErrors.type = i18n.t('validation:phoneAndTypeRequired');
        arrayErrors[index] = phoneErrors;
      }

      if (phone && phone.phone && !test(PHONE_REGEX, phone.phone)) {
        phoneErrors.phone = i18n.t('validation:phoneNotCorrect');
        arrayErrors[index] = phoneErrors;
      }
    });

    if (arrayErrors.length) {
      errors = arrayErrors;
    }
  }

  return errors;
};
